import FiltersBarMobile from './FiltersBarMobile';
import { withI18n } from 'react-i18next';
export default withI18n()(FiltersBarMobile);
